import React from 'react';
import { useEditorActions } from '../../store/editorStore.jsx';

export function ColumnsCanvas({ block, children }) {
  const gap = block.attrs.gap || 16;
  return (
    <div
      className="editor-columns-block"
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${React.Children.count(children) || 2}, 1fr)`,
        gap: `${gap}px`,
        minHeight: 80,
      }}
    >
      {children}
    </div>
  );
}

export function ColumnsInspector({ block }) {
  const { updateAttrs } = useEditorActions();
  const gap = block.attrs.gap || 16;

  return (
    <div className="p-3">
      <div className="mb-3">
        <label className="form-label fw-semibold small">Column Gap (px)</label>
        <input
          type="range"
          className="form-range"
          min={0}
          max={48}
          step={4}
          value={gap}
          onChange={(e) => updateAttrs(block.id, { gap: Number(e.target.value) })}
        />
        <small className="text-muted">{gap}px</small>
      </div>
    </div>
  );
}

export function ColumnCanvas({ block, children }) {
  return (
    <div
      className="editor-column-block"
      style={{
        border: '1px dashed #adb5bd',
        borderRadius: 4,
        padding: '8px',
        minHeight: 60,
      }}
    >
      {children}
    </div>
  );
}

export function ColumnInspector() {
  return (
    <div className="p-3">
      <p className="text-muted small">Add blocks inside this column.</p>
    </div>
  );
}
